var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex column justify-content-center align-items-center",on:{"click":_vm.handleChangeCommon}},[_c('img',{attrs:{"src":_vm.src}}),_c('span',{staticClass:"f-gray fr-14 mt-8"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }